import React from 'react';
import analyticsTrack from '@lib/analytics/analyticsTrack';
import { useTheme } from '@components/theme';
import classNames from 'classnames';
import breakpoints from '@constants/breakpoints';
import PrismicImage from '@components/shared/images/atoms/Image/PrismicImage';
import { useMaxBreakpoint } from '@hooks/useMediaQuery/useMediaQuery';
import styles from './CollectionFeature.module.scss';
import { ICollectionFeature } from '../../model/collectionFeature';

const CollectionFeature = ({
  firstSection,
  secondSection,
  showSecondSection
}: ICollectionFeature) => {
  const theme = useTheme();
  const isMobile = useMaxBreakpoint('large-tablet');

  const trackSectionClicked = (section: any) => {
    analyticsTrack('cta_clicked', {
      title: `Shop Landing Page | Collection Feature | ${section.title}`,
      ctaLabel: section.ctaLabel,
      section
    });
  };

  return (
    <section className={styles.CollectionFeature}>
      <div className={styles.Content}>
        <div className={styles.FirstSection}>
          <div className={styles.TextContent}>
            <h2 className={theme.styles.Title1}>{firstSection.title}</h2>
            <p>{firstSection.description}</p>

            {firstSection.ctaLabel && (
              <a
                role="button"
                href={firstSection.ctaUrl}
                className={
                  classNames(theme.styles.Button, theme.styles.Primary, theme.styles.Small)
                }
                onClick={() => trackSectionClicked(firstSection)}
              >
                {firstSection.ctaLabel}
              </a>
            )}
          </div>
          <a
            aria-label={`collection feature - ${firstSection.ctaLabel}`}
            role="button"
            href={firstSection.ctaUrl}
            onClick={() => trackSectionClicked(firstSection)}
          >
            <PrismicImage
              className={ styles.FirstSectionImage }
              lazy={false}
              image={firstSection.image}
              breakpoints={{
                desktop: breakpoints.desktop,
                mobile: breakpoints['medium-desktop']
              }}
            />
          </a>
        </div>
        {showSecondSection && (
          <div className={styles.SecondSection}>
            <div className={styles.ImagesWrapper}>
              <a
                aria-label={`collection feature - ${secondSection.ctaLabel}`}
                role="button"
                href={secondSection.ctaUrl}
                onClick={() => trackSectionClicked(secondSection)}
              >
                <PrismicImage
                  className={ styles.SecondSectionImage }
                  lazy={false}
                  image={secondSection.firstImage}
                  breakpoints={{
                    desktop: breakpoints.desktop,
                    mobile: breakpoints['medium-desktop']
                  }}
                />
              </a>

              {!isMobile && (
                <a
                  aria-label={`collection feature - ${secondSection.ctaLabel}`}
                  role="button"
                  href={secondSection.ctaUrl}
                  onClick={() => trackSectionClicked(secondSection)}
                >
                  <PrismicImage
                    className={ styles.SecondSectionImage }
                    lazy={false}
                    image={secondSection.secondImage}
                    breakpoints={{
                      desktop: breakpoints.desktop,
                      mobile: breakpoints['medium-desktop']
                    }}
                  />
                </a>
              )}
            </div>

            <div className={styles.TextContent}>
              <h2 className={theme.styles.Title1}>{secondSection.title}</h2>
              <p>{secondSection.description}</p>

              {secondSection.ctaLabel && (
              <a
                role="button"
                href={secondSection.ctaUrl}
                className={
                  classNames(theme.styles.Button, theme.styles.Primary, theme.styles.Small)
                }
                onClick={() => trackSectionClicked(secondSection)}
              >
                {secondSection.ctaLabel}
              </a>
              )}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default CollectionFeature;
